/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import Box from '@mui/material/Box';
// import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const Process = () => {
  return (
    <Box>
      {/* <Typography
        sx={{
          textTransform: 'uppercase',
          fontWeight: 'medium',
        }}
        gutterBottom
        color={'secondary'}
        align={'center'}
      >
        
      </Typography> */}
      <Typography fontWeight={800} variant={'h4'} gutterBottom align={'center'}>
      OVERVIEW<br/>
      </Typography>
      <Typography fontWeight={700} variant={'h5'} gutterBottom >
        <br/>‘WE CARE, WE SHARE, FOR THE FUTURE WE PREPARE’
      </Typography>
      <Typography component={'p'}
        color={'text.secondary'}
        align={'justify'}>
      NPS Yeshwanthpur is a leading educational institution committed to provide a
holistic education and is a forerunner in setting the highest academic standards.
NPS YPR is dedicated to the overall personality development of our students by
honing their leadership skills and looking after their emotional well-being.<br/><br/>
The school is an integrated community of parents, teachers and children from all
over the country. We at NPS strongly believe that the environment is the best
educator. With a supporting environment, which involves both family and the
institution we strive to develop in all learners the strong values, emotional wellbeing
and crucial 21 century skills such as creativity, critical thinking, communication,
collaboration, self-direction and self-management. This will empower them to
become global citizens in this ever changing world.<br/><br/>
Our teaching methodology enables our students to do well for themselves and do
good for our world in a manner that authentically reflects the very best in each of
them by inculcating a positive attitude and inquiry-based learning.<br/>
      </Typography>
      <Typography fontWeight={700} variant={'h5'} gutterBottom >
        <br/>OUR VISION
      </Typography>
      <Typography component={'p'}
        color={'text.secondary'}
        align={'justify'}>
      In a learner-centric, engaging and effective environment, integrated with methods
assimilating blended learning, inclusive of technology and updated instructional
methods, develop inquisitive learners with integrity of character driven by
excellence, to actualize their potential in pursuit of being <strong>Life - Long Learners and
Global Citizens.</strong> 
      </Typography>
      <Typography fontWeight={700} variant={'h5'} gutterBottom >
        <br/>OUR MISSION
      </Typography>
      <Typography component={'p'}
        color={'text.secondary'}
        align={'justify'}>
      Our mission is to provide a nurturing atmosphere where everyone is valued and
respected. All staff members, in partnership with parents and families are fully
committed to the students’ over all development. Students are empowered to meet
current and future challenges to develop social awareness, civic responsibility and
enabling personal growth.
      </Typography>
      
      <Typography fontWeight={700} variant={'h5'} gutterBottom >
        <br/>OUR SHARED BELIEFS ON TEACHING AND LEARNING
      </Typography>
      <Typography
        component={'p'}
        color={'text.secondary'}
        align={'justify'}
      >
      
        •	Children learn in an environment that is inclusive, safe and where they feel valued and supported. 
        <br />
        •	Learning experiences should respect and accommodate differences between learners. 
        <br />
        •	Parents, teachers and students share common goals, interact positively and are mutually supportive. 
        <br/>
        •	Learning should be meaningful, enjoyable, relevant and consistent.
        <br/>
        •	Parents and teachers work in partnership to develop students who are independent, self-reflective and responsible.
        <br/>
        •	Parents, teachers and students share and actively promote essential community values.

      </Typography>

      <Typography fontWeight={700} variant={'h5'} gutterBottom >
        <br/>CURRICULUM OFFERED
      </Typography>
      <Typography
        component={'p'}
        color={'text.secondary'}
        align={'justify'}
      >
       
        National Public School Yeshwanthpur is a pioneer CBSE school where students explore their inherent skills and potential in a student-centric fun-based learning space. Our school offers state-of-the-art infrastructure and quality education that include digital learning rooms, skill-based programmes and enumeourous co-curricular activities that leads to profound holistic learning which is best suited for 21st century modern education. 
        <br /><br/>
        We provide excellent opportunities to our students to think of innovative and arrive at cutting-edge solutions that boost their creative capabilities. With the outstanding interdisciplinary teaching, our students get a chance to apply knowledge, principles and value to more than one academic subject. 
        <br /><br></br>
        The integration of our In-house holistic pedagogy into the world acclaimed CBSE curriculum adds finesse and a strong foundation in students' academic path, hones their essential life skills and enables them to achieve a place in top universities across the globe.
        <br/>

      </Typography>
    </Box>
    
  );
};

export default Process;
